const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/metakat.ts';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';
import { actionTypes } from '@cistec/common_web/actions/metakatActions';

import { LOAD_FROM_METAKAT_FOR_FORM } from '@cistec/common_web/components/Forms/actions';

export function loadMultiMetaKatRecords(list: string[]) {
    const endpoint = 'metakat/multiload';
    const meta = { list };
    const body = JSON.stringify({ List: list });
    return createPatapiCall(actionTypes.multiloadMetaKatRecords, endpoint, HttpMethod.POST, meta, body);
}

export function loadFromMetaKatForCIS4m(icode: string) {
    const endpoint = `metakat/icode/${icode}`;
    const meta = { pcode: icode };
    return createPatapiCall(LOAD_FROM_METAKAT_FOR_FORM, endpoint, HttpMethod.GET, meta);
}
